import { DEFAULT_LIMIT_PLAN, DEFAULT_LIMIT_PROVIDER } from 'favoriteList/constants/defaultValue';
import type { PlanListSort } from 'favoriteList/constants/favoriteLists';
import { ProviderListSort, ServiceType } from 'favoriteList/constants/favoriteLists';
import { SORT_OPTIONS_PLAN, SORT_OPTIONS_PROVIDER } from 'favoriteList/constants/filters';
import type { universalRouterProps } from 'favoriteList/core/universalRouter/types';
import { fetchPlanList, fetchProviderList } from 'favoriteList/store/providerPlan/actions';
import type { Query, RequestBody, SearchQuery } from 'ProviderPlan-Types';

export const getRequestFilter = (query?: Query) => {
  const filters = query?.f_squeezes as string | string[];
  const isParent = query?.isParent as string | string[];

  // Convert isParent to an array if it's a string
  const isParentArray = typeof isParent === 'string' ? [isParent] : isParent || [];

  // Convert filters to an array if it's a string
  const filtersArray = typeof filters === 'string' ? [filters] : filters || [];

  // Remove duplicates and filter out values that are in isParentArray
  const uniqueFilters = [...new Set(filtersArray)].filter(
    (filter) => !isParentArray.includes(filter),
  );

  return uniqueFilters;
};

export const getRequestSort = (isProvider: boolean, query?: Query) => {
  const sortOrder = query?.f_sort;
  const sortOption = isProvider
    ? SORT_OPTIONS_PROVIDER?.[sortOrder as ProviderListSort]?.value
    : SORT_OPTIONS_PLAN?.[sortOrder as PlanListSort]?.value;
  return sortOption || ProviderListSort.LATEST;
};

export default (
  { store: { dispatch } }: universalRouterProps,
  context: SearchQuery,
  isDomestic: boolean,
  isPlanList: boolean,
) => {
  const req: RequestBody = {
    serviceType: isDomestic ? ServiceType.DOMESTIC : (ServiceType.OVERSEAS_HOTEL as any),
    offset: Number(context.query?.offset) || 0,
    limit: isPlanList ? DEFAULT_LIMIT_PLAN : DEFAULT_LIMIT_PROVIDER,
    filters: getRequestFilter(context.query),
    sortOrder: getRequestSort(!isPlanList, context.query),
    adultNum: 1,
    roomNum: 1,
  };

  if (!isPlanList) {
    return Promise.all([dispatch(fetchProviderList(req))]);
  } else {
    return Promise.all([dispatch(fetchPlanList(req))]);
  }
};
